// extracted by mini-css-extract-plugin
export default {"autoActionScreen":"Join_autoActionScreen__eHZQx","gcLogo":"Join_gcLogo__eiMYq","roomCode":"Join_roomCode__cC72i","cancelButton":"Join_cancelButton__Ah1yi"};